import { useQuery } from "@tanstack/react-query";
import { organizationsApi } from "@/shared/api/organizations";
import type { UserOrganization } from "@/entities/user/model/types";

export function useUserOrganizationsWithRoles(userId?: string) {
  return useQuery({
    queryKey: ["user-organizations", userId],
    queryFn: async () => {
      if (!userId) return [];

      const organizations =
        await organizationsApi.getUserOrganizationsById(userId);

      return organizations.map((org) => ({
        id: org.id,
        name: org.name,
        url: org.url || "",
        avatarUrl: org.avatarUrl || undefined,
        role: org.currentUserRole || "member",
      })) as UserOrganization[];
    },
    enabled: !!userId,
  });
}
